import * as React from "react";
import styled from "styled-components";
import useExpandedSections from "components/common/EntityDataTable/hooks/useExpandedSections";
import streamCategoryName from "logic/streams/streamCategoryName";
import { COLUMN_WIDTH } from "components/common/EntityDataTable/Constants";
import isSafeReferenceUrl from "./referenceUrl";
const ClickableName = styled.span`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.global.link};

  &:hover {
    text-decoration: underline;
  }
`;
const NameCell = ({ chain }) => {
  const { toggleSection } = useExpandedSections();
  return /* @__PURE__ */ React.createElement(ClickableName, { onClick: () => toggleSection(chain.id, "detailsExpandedSection") }, chain.name);
};
const columnRenderers = {
  attributes: {
    name: {
      renderCell: (_value, chain) => /* @__PURE__ */ React.createElement(NameCell, { chain })
    },
    description: {
      renderCell: (_value, chain) => {
        var _a;
        return /* @__PURE__ */ React.createElement(React.Fragment, null, (_a = chain.description) != null ? _a : "\u2014");
      }
    },
    threat_actor: {
      renderCell: (_value, chain) => {
        var _a;
        return /* @__PURE__ */ React.createElement(React.Fragment, null, (_a = chain.threat_actor) != null ? _a : "\u2014");
      },
      staticWidth: 150
    },
    source: {
      renderCell: (_value, chain) => {
        var _a;
        return /* @__PURE__ */ React.createElement(React.Fragment, null, (_a = chain.source) != null ? _a : "\u2014");
      },
      staticWidth: 150
    },
    created_at: {
      // Already a date-only YYYY-MM-DD string (LocalDate on the backend), so render it verbatim.
      renderCell: (_value, chain) => {
        var _a;
        return /* @__PURE__ */ React.createElement(React.Fragment, null, (_a = chain.created_at) != null ? _a : "\u2014");
      },
      staticWidth: "matchHeader"
    },
    targeted_technologies: {
      renderCell: (_value, chain) => {
        var _a;
        return /* @__PURE__ */ React.createElement(React.Fragment, null, ((_a = chain.targeted_technologies) == null ? void 0 : _a.length) ? chain.targeted_technologies.join(", ") : "\u2014");
      },
      staticWidth: COLUMN_WIDTH.tags
    },
    industries: {
      renderCell: (_value, chain) => {
        var _a;
        return /* @__PURE__ */ React.createElement(React.Fragment, null, ((_a = chain.industries) == null ? void 0 : _a.length) ? chain.industries.join(", ") : "\u2014");
      },
      staticWidth: COLUMN_WIDTH.tags
    },
    stream_categories: {
      renderCell: (_value, chain) => {
        var _a;
        return /* @__PURE__ */ React.createElement(React.Fragment, null, ((_a = chain.stream_categories) == null ? void 0 : _a.length) ? chain.stream_categories.map(streamCategoryName).join(", ") : "\u2014");
      },
      staticWidth: COLUMN_WIDTH.tags
    },
    reference_url: {
      // Only render a clickable link for a safe http(s) URL; otherwise show the raw value as plain
      // text (matching the ContentPackDetails guard) so a non-http(s) URL can't become a live link.
      renderCell: (_value, chain) => {
        if (!chain.reference_url) return /* @__PURE__ */ React.createElement(React.Fragment, null, "\u2014");
        return isSafeReferenceUrl(chain.reference_url) ? /* @__PURE__ */ React.createElement("a", { href: chain.reference_url, target: "_blank", rel: "noopener noreferrer" }, chain.reference_url) : /* @__PURE__ */ React.createElement(React.Fragment, null, chain.reference_url);
      }
    },
    definitions_count: {
      renderCell: (_value, chain) => /* @__PURE__ */ React.createElement(React.Fragment, null, `${chain.enabled_definitions_count} / ${chain.definitions_count} enabled`),
      staticWidth: "matchHeader"
    }
  }
};
export default columnRenderers;
